<template>
  <!-- Header box -->
  <v-container
    id="gewerbe-summary-box"
    :class="{ 'sticky-box': !isEdge() }"
    class="fixed-box summary-box round-corners pa-0"
  >
    <div class="padding-box1">
      <h1>Zusammenfassung</h1>

      <v-divider class="h1h2divier" />

      <h2>Basisdaten</h2>

      <gewerbe-summary-box-line>{{ nameAbreviate }} <span class="dmb-inline-nowrap">{{ versicherungsnehmer.rechtsform ? versicherungsnehmer.rechtsform : "" }}</span></gewerbe-summary-box-line>
      <gewerbe-summary-box-line>Laufzeit: {{ vertrag.laufzeit }} {{ vertrag.laufzeit > 1 ? 'Jahre' : 'Jahr' }}</gewerbe-summary-box-line>
      <gewerbe-summary-box-line>{{ basisdaten }}</gewerbe-summary-box-line>
    </div>

    <!-- Detail box -->
    <div v-if="produkte.length > 0 || isKompex" class="scrollable-box padding-box2 bg-dimmed">
      <h2>Versicherungs&shy;schutz</h2>

      <div v-if="isKompex">
        <h3>KOMPEX</h3>
        <gewerbe-summary-box-line v-if="!isKompexOhneI">Firma/Gewerbe, Immobilie, Verkehr</gewerbe-summary-box-line>
        <gewerbe-summary-box-line v-if="isKompexOhneI">Firma/Gewerbe, Verkehr</gewerbe-summary-box-line>
        <gewerbe-summary-box-line v-if="isKompexOhneI">ohne gewerbliche Immobilien</gewerbe-summary-box-line>
        <gewerbe-summary-box-line
          v-if="matrixSelection.produkte.length > 0"
        >Selbstbeteiligung {{ matrixSelection.sb.gewerbe }} €</gewerbe-summary-box-line>
        <div v-if="!excludeGF">
          <gewerbe-summary-box-line>inklusive private Absicherung</gewerbe-summary-box-line>
          <gewerbe-summary-box-line>Privat, Beruf, Verkehr, Wohnen</gewerbe-summary-box-line>
          <gewerbe-summary-box-line
            v-if="matrixSelection.produkte.length > 0"
          >Selbstbeteiligung {{ matrixSelection.sb.privat }} €</gewerbe-summary-box-line>
        </div>
        <gewerbe-summary-box-line v-if="hasDeckung('SPEZ-PBV') || hasDeckung('SPEZ-PBV+MIET')">
          <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
          <span
            slot="right"
          >{{ $helpers.toGermanFloatString(kompexHauptproduktPraemie(zahlweise)) }} €</span>
        </gewerbe-summary-box-line>
      </div>

      <div v-if="!isKompex">
        <div v-if="hasProdukt('FIRM')">
          <h3>Firma/Gewerbe</h3>
          <gewerbe-summary-box-line
            v-if="hasOneProdukt('FIRM') && matrixSelection.produkte.length > 0"
          >Selbstbeteiligung {{ matrixSelection.sb.gewerbe }} €</gewerbe-summary-box-line>
          <gewerbe-summary-box-line v-if="hasDeckung('FIRM')">
            <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
            <span
              slot="right"
            >{{ $helpers.toGermanFloatString(findDeckung('FIRM').praemie[zahlweise]) }} €</span>
          </gewerbe-summary-box-line>
        </div>

        <div v-if="hasProdukt('VERK')">
          <h3 class="mt-2">Verkehr</h3>
          <gewerbe-summary-box-line
            v-if="hasOneProdukt('VERK') && matrixSelection.produkte.length > 0"
          >Selbstbeteiligung {{ matrixSelection.sb.gewerbe }} €</gewerbe-summary-box-line>
          <gewerbe-summary-box-line v-if="hasDeckung('VERKA') || hasDeckung('VERKB') || hasDeckung('VERKC')">
            <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
            <span
              slot="right"
            >{{ $helpers.toGermanFloatString(verkehrPraemie) }} €</span>
          </gewerbe-summary-box-line>
        </div>

        <div v-if="hasProdukt('MIET')">
          <h3 class="mt-2">Immobilie</h3>
          <gewerbe-summary-box-line
            v-if="hasOneProdukt('MIET') && matrixSelection.produkte.length > 0"
          >Selbstbeteiligung {{ matrixSelection.sb.gewerbe }} €</gewerbe-summary-box-line>
          <gewerbe-summary-box-line v-if="hasDeckung('MIET')">
            <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
            <span
              slot="right"
            >{{ $helpers.toGermanFloatString(gewerbeDeckungPrice('MIET')) }} €</span>
          </gewerbe-summary-box-line>
        </div>

        <gewerbe-summary-box-line
          v-if="!isKompex &&  matrixSelection.produkte.length > 1"
          class="mt-2"
        >Selbstbeteiligung {{ matrixSelection.sb.gewerbe }} €</gewerbe-summary-box-line>
      </div>

      <div v-if="hasDeckung('SPEZ-T')">
        <h3 class="mt-2">Firmen-Vertrags-Rechtsschutz</h3>
        <gewerbe-summary-box-line v-if="hasDeckung('SPEZ-T')">
          <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
          <span
            slot="right"
          >{{ $helpers.toGermanFloatString(findDeckung('SPEZ-T').praemie[zahlweise]) }} €</span>
        </gewerbe-summary-box-line>
      </div>

      <div v-if="hasDeckung('SPEZ-SSRG')">
        <h3 class="mt-2">Spezial-Straf-Rechtsschutz</h3>
        <gewerbe-summary-box-line v-if="hasDeckung('SPEZ-SSRG')">
          <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
          <span
            slot="right"
          >{{ $helpers.toGermanFloatString(findDeckung('SPEZ-SSRG').praemie[zahlweise]) }} €</span>
        </gewerbe-summary-box-line>
      </div>

      <div v-if="hasDeckung('MIETZ') && gewerbeDeckungPrice('MIETZ') > 0">
        <h3 class="mt-2">Verpachtete gew. Immobilien</h3>
        <gewerbe-summary-box-line v-if="hasDeckung('MIETZ')">
          <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
          <span
            slot="right"
          >{{ $helpers.toGermanFloatString(gewerbeDeckungPrice('MIETZ')) }} €</span>
        </gewerbe-summary-box-line>
      </div>

      <!-- Zusatzbausteine für den privaten Bereich (Geschäftsführer) -->
      <div v-if="isKompex && !excludeGF">
        <div v-for="(gf, index) in geschaeftsfuehrer" :key="gf.key">
          <v-divider class="h1h2divier" />
          <h2 class="summary-box-line">Privater Bereich</h2>

          <gewerbe-summary-box-line>
            <span slot="left"
                  class="dmb-nowrap">{{ !gf.firstname && !gf.lastname ? `${index + 1}. Inhaber` : `${gf.firstname||""} ${gf.lastname||""}` }}
            </span>
            <span slot="right">{{ index > 0 ? $helpers.toGermanFloatString(gfDeckung(gf).praemie[zahlweise]) + ' €': 'mitversichert' }}</span>
          </gewerbe-summary-box-line>
          <div
            v-for="deckung in zusatzbausteineGf(gf)"
            :key="deckung.pk"
          >
            <h3 class="mt-2">{{ produktLabel(deckung.produkt) }}</h3>
            <gewerbe-summary-box-line>Selbstbeteiligung {{ deckung.sb.privat }} €</gewerbe-summary-box-line>
            <gewerbe-summary-box-line>
              <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
              <span slot="right">
                {{ deckung.praemie[zahlweise] === 0 ? "mitversichert" : $helpers.toGermanFloatString(deckung.praemie[zahlweise]) +  ' €' }}
              </span>
            </gewerbe-summary-box-line>
          </div>

          <div v-if="vermieteteWohneinheitenGf(gf).length > 0">
            <h3 class="mt-2">Vermietete Wohneinheiten ({{ vermieteteWohneinheitenGf(gf).length }})</h3>
            <gewerbe-summary-box-line>Selbstbeteiligung {{ vermieteteWohneinheitenGf(gf)[0].sb.privat }} €</gewerbe-summary-box-line>
            <gewerbe-summary-box-line>
              <span slot="left">{{ praemienName('' + vertrag.zahlweise) }}</span>
              <span
                slot="right"
              >{{ $helpers.toGermanFloatString(vermieteteWohneinheitenGfPraemie(gf)) }} €</span>
            </gewerbe-summary-box-line>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer box -->
    <div v-if="vertrag.praemie[zahlweise] > 0" class="padding-box3">
      <gewerbe-summary-box-line>
        <h3 slot="left">{{ praemienName('' + vertrag.zahlweise) }}</h3>
        <h3 slot="right" data-cy="summary-vertragPraemie">{{ $helpers.toGermanFloatString(vertrag.praemie[zahlweise]) }} €</h3>
      </gewerbe-summary-box-line>
      <gewerbe-summary-box-line v-if="zahlweiseOfMinimumPraemie != vertrag.zahlweise">
        <h3 slot="left">{{ praemienName('' + zahlweiseOfMinimumPraemie) }}</h3>
        <h3 slot="right" data-cy="summary-vertragMinimumPraemie"
        >{{ $helpers.toGermanFloatString(vertrag.praemie['z'+ zahlweiseOfMinimumPraemie ]) }} €</h3>
      </gewerbe-summary-box-line>
      <div v-if="isVorschlagAllowed" class="padding-box3">
        <v-row class="kurzangebot-btn fill-parent" align="center" justify="center" no-gutters>
          <v-btn
            color="primary"
            class="standard-button ma-2"
            @click="createVorschlag"
          >Vorschlag erstellen</v-btn>
          <!-- @click="$emit('kurzangebot')"            -->
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import BrowserDetectionMixin from '@/components/helper/BrowserDetectionMixin';
import GewerbeSummaryBoxLine from '@/components/gewerberechner/GewerbeSummaryBoxLine';
import { mapState } from 'vuex';
import { mapTwoWay } from '@/store/twowayBindingMixin';
import twowayBinding from '@/store/twowayBindingMixin';
import keyTranslatorMixin from '@/components/helper/keyTranslatorMixin';
import StepperMixin from '../StepperMixin';

export default {
  name: 'GewerbeSummaryBox',
  components: { GewerbeSummaryBoxLine },
  mixins: [
    twowayBinding,
    BrowserDetectionMixin,
    keyTranslatorMixin,
    StepperMixin
  ],
  computed: {
    ...mapGetters([
      'versicherungsnehmer',
      'anzahlMitarbeiter',
      'anzahlFahrzeuge',
      'kompexHauptproduktPraemie',
      'gewerbeDeckungPrice',
      'geschaeftsfuehrer'
    ]),
    ...mapState({
      activeStepNumber: state => state.s.gewerbe.activeStepNumber
    }),
    ...mapTwoWay(['vertrag', 'immobilien', 'deckungen', 'personen']),
    ...mapTwoWay(
      ['isKompex', 'isKompexOhneI', 'excludeGF', 'produkte', 'matrixSelection'],
      {},
      'gewerbe.ui'
    ),

    zahlweise() {
      return 'z' + this.vertrag.zahlweise;
    },

    basisdaten() {
      let result = '';
      if (this.isKompex || this.hasProdukt('FIRM')) {
        result += this.anzahlMitarbeiter + ' Mitarbeiter';
      }
      if (!this.isKompex && this.hasProdukt('VERK')) {
        if (result.length > 0) {
          result += ', ';
        }
        result +=
          '' +
          this.anzahlFahrzeuge +
          (this.anzahlFahrzeuge === 1 ? ' Fahrzeug' : ' Fahrzeuge');
      }
      if (!this.isKompex && this.hasProdukt('MIET')) {
        if (result.length > 0) {
          result += ', ';
        }
        result +=
          '' +
          this.immobilien.length +
          (this.immobilien.length === 1 ? ' Immobilie' : ' Immobilien');
      }
      return result;
    },

    isVorschlagAllowed() {
      return (
        this.activeStepNumber === 2 && this.matrixSelection.produkte.length > 0
      );
    },

    zahlweiseOfMinimumPraemie() {
      for (let z of [12, 4, 2, 1]) {
        if (this.vertrag.praemie['z' + z] > 15) {
          return z;
        }
      }
      return 1;
    },

    verkehrPraemie() {
      return this.deckungen
        .filter(d => d.ref === 'vn1' && ['VERKA', 'VERKB', 'VERKC'].includes(d.produkt))
        .map(d => d.praemie[this.zahlweise])
        .reduce((sum, value) => sum + value, 0);
    },

    nameAbreviate() {
      //avoid x-overflow of the summarybox
      return this.versicherungsnehmer.name
        ? (this.versicherungsnehmer.name.length >= 30 ? this.versicherungsnehmer.name.slice(0,27) + '...' : this.versicherungsnehmer.name)
        : "";
    }


  },

  methods: {
    hasProdukt(p) {
      return this.produkte.indexOf(p) > -1;
    },
    hasOneProdukt(p) {
      if (this.produkte.length === 1) {
        return this.produkte.indexOf(p) > -1;
      } else {
        return false;
      }
    },
    findDeckung(produkt) {
      return this.deckungen.find(d => d.ref === 'vn1' && d.produkt === produkt);
    },
    hasDeckung(produkt) {
      return this.findDeckung(produkt) !== undefined;
    },
    gfDeckung(gf) {
      return this.deckungen.find(d => d.ref === gf.key && d.produkt === 'SPEZ-PRIV');
    },
    zusatzbausteineGf(gf) {
      return this.deckungen
        .filter(d => d.ref === gf.key && d.produkt !== 'SPEZ-PRIV' && d.produkt !== 'SPEZ-PRIVVM')
        .map((d, i) => {
          let result = {};
          Object.assign(result, d);
          result.pk = '' + d.ref + '_' + d.produkt + '_' + i;
          return result;
        });
    },
    vermieteteWohneinheitenGf(gf) {
      return this.deckungen.filter(
        d => d.ref === gf.key && d.produkt === 'SPEZ-PRIVVM'
      );
    },
    vermieteteWohneinheitenGfPraemie(gf) {
      return this.vermieteteWohneinheitenGf(gf).reduce((sum, v) => {
        return sum + v.praemie[this.zahlweise];
      }, 0);
    },
    produktLabel(produkt) {
      const labels = [
        {
          produkt: 'SPEZ-PRIVCYBER',
          label: 'Cyber-Rechtsschutz'
        },
        {
          produkt: 'SPEZ-PRIVPRESTIGE',
          label: 'Erweiterung PRESTIGE'
        },
        {
          produkt: 'SPEZ-PRIVSSR',
          label: 'Erweiterung SSR im privaten Bereich'
        },
        {
          produkt: 'SPEZ-PRIVZW',
          label: 'Rechtsschutz für weitere Ferienwohnung'
        },
        {
          produkt: 'SPEZ-PRIVVM',
          label: 'Vermietete Wohneinheiten'
        }
      ];
      const result = labels.find(l => l.produkt === produkt);
      return result ? result.label : produkt;
    },


    createVorschlag() {
      let fnError = function() {
        this.$parent.openInvalidAccordions(this.activeStepNumber);
        this.$parent.errorSnackbar.errormessages = [
          'Bitte überprüfen Sie Ihre Eingaben.'
        ];
        this.$parent.errorSnackbar.displayerrors = true;
      }.bind(this);

      let fnSuccess = function() {
        this.$emit('kurzangebot');
      }.bind(this);

      // validate parent-page before creation

      let validators = this.$parent.getStepValidators(this.activeStepNumber);
      validators = validators.map(v => v.validateAll());
      Promise.all(validators)
        .then(res => {
          res.includes(false) ? fnError() : fnSuccess();
        })
        .catch(err => {
          console.log(`VALIDATION ERROR: ${err.message}`);
          fnError();
        });
    },

  }
};
</script>

<style scoped>
.padding-box1 {
  padding: 16px 16px 8px 16px;
}

.padding-box2 {
  padding: 8px 16px 8px 16px;
}

.padding-box3 {
  padding: 16px 16px 8px 16px;
}

.kurzangebot-btn {
  margin-top: 0;
}

.sticky-box {
  position: sticky;
  position: -webkit-sticky;
}

.fixed-box {
  top: 180px !important;
  width: 100%;
  z-index: 6;
  margin: 0;
}

@media screen and (max-width: 1100px), screen and (max-height: 800px) {
  .fixed-box {
    top: 92px !important;
  }
}

.scrollable-box {
  max-height: calc(100vh - 136px - 48px - 233px - 136px) !important;
  overflow-y: scroll;
}

.summary-box {
  max-height: calc(100vh - 136px - 48px) !important;
  background-color: #ebebeb !important;
}

.summary-box h1 {
  font-size: 24px !important;
  font-weight: 400;
  line-height: 32px !important;
  color: #0085cf !important;
}

.summary-box h2 {
  line-height: 24px !important;
  font-size: 20px !important;
  font-weight: 400;
  color: #0085cf !important;
}

.summary-box h3 {
  line-height: 24px !important;
  font-size: 16px !important;
  font-weight: 400;
  color: #0085cf !important;
}

.summary-box .summary-box-line {
  line-height: 24px !important;
  font-weight: 400;
  font-size: 16px;
  max-width: 263px;
  min-width: 263px;
}

.summary-box .v-divider {
  margin-top: 8px;
  margin-bottom: 0;
}

.text-bold {
  font-weight: 700 !important;
}
</style>
